import { formatDateToDateString } from "@components/inputs/date/utils";
import { BillingPricingEntity, EntitySetName, IBillingPricingEntity } from "@odata/GeneratedEntityTypes";
import { ProductCode } from "@odata/GeneratedEnums";
import { OData } from "@odata/OData";
import { ODataQueryResult } from "@odata/ODataParser";
import { isDefined } from "@utils/general";

import { REST_API_URL } from "../../constants";
import { addCompanyIdToUrl } from "../../contexts/appContext/AppContext.utils";
import BindingContext from "../../odata/BindingContext";
import { getUtcDate } from "../../types/Date";
import customFetch, { getDefaultPostParams } from "../../utils/customFetch";

export enum PurchaseWizardDialogScreen {
    SelectProductType,
    InvoicingInfo,
    PaymentType
}

export enum PurchaseDialogPaymentType {
    Card = "Card",
    Wire = "Wire"
}

export const consentPath = BindingContext.localContext("consent");
export const individualSettingsTextPath = BindingContext.localContext("individualSettingsText");
export const individualSettingsCompanyPath = BindingContext.localContext("individualSettingsCompany");

const PURCHASE_API = `${REST_API_URL}/Subscription/Purchase`;

interface IPurchaseEvalaArgs {
    productCode: ProductCode;
    paymentType: PurchaseDialogPaymentType;
    phoneNumber?: string;
    individualCompanyId?: number;
}

export interface IPurchaseEvalaResponseData {
    Url: string;
}

export const purchaseEvala = async (args: IPurchaseEvalaArgs) => {
    let url = `${PURCHASE_API}/${args.paymentType}`;

    if (isDefined(args.individualCompanyId)) {
        url = addCompanyIdToUrl(url, args.individualCompanyId);
    }

    return await customFetch(url, {
        ...getDefaultPostParams(),
        body: JSON.stringify({
            PhoneNumber: args.phoneNumber,
            ProductCode: args.productCode
        })
    });
};

export const fetchProductPrices = async (oData: OData, productCode?: ProductCode): Promise<ODataQueryResult<IBillingPricingEntity[]>> => {
    const today = formatDateToDateString(getUtcDate());
    const query = oData.getEntitySetWrapper(EntitySetName.BillingPricings).query()
        .filter(`${BillingPricingEntity.DateValidFrom} le ${today} AND (${BillingPricingEntity.DateValidTo} ge ${today} or ${BillingPricingEntity.DateValidTo} eq null)`);

    if (productCode) {
        query.filter(`${BillingPricingEntity.ProductCode} eq '${productCode}'`, "AND");
    }

    return await query.fetchData<IBillingPricingEntity[]>();
};